module.exports = __webpack_public_path__ + "static/media/03.378b8729.jpg";